
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'6-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            결제 관리 - 결제 현황 {{ $route.query.reservation_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.reservation_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_join_division'>예약 구분<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_join_division'
                readonly
                v-model="statusData.reservationJoinDivision"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_registe'>예약 신청일<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_registe'
                readonly
                v-model="statusData.reservationRegiste"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_name'>예약 여행명<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'travel_product_name'
                readonly
                v-model="statusData.travelProductName"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='schedule_start_day'>여행 출발일<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'schedule_start_day'
                readonly
                v-model="statusData.scheduleStartDay"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_customer_name'>예약자명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_customer_name'
                maxLength="50"
                placeholder = "예약자명을 50자 내 입력해 주세요."
                v-model="formData.reservationCustomerName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.reservationCustomerNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_customer_phone_number'>휴대전화<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_customer_name'
                maxLength="50"
                placeholder = "휴대전화를 입력해 주세요."
                v-model="formData.reservationCustomerPhoneNumber"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.reservationCustomerPhoneNumberError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_customer_phone_number_2'>비상연락처</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_customer_phone_number_2'
                maxLength="50"
                placeholder = "휴대전화를 입력해 주세요."
                v-model="formData.reservationCustomerPhoneNumber2"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.reservationCustomerPhoneNumber2Error}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_customer_email'>이메일</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_customer_email'
                maxLength="50"
                placeholder = "이메일을 입력해 주세요."
                v-model="formData.reservationCustomerEmail"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.reservationCustomerEmailError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_memo'>관리자메모</label>
              <textarea
                class="Admin_PageDetail_textarea"
                id="reservation_memo"
                maxLength="500"
                rows="10"
                placeholder="메모를 입력해 주세요."
                v-model="formData.reservationMemo"
              />
              <br>
              <p>{{ formData.reservationMemo.length }}/500</p>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationCancellationRequestStatus === 1">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_cancellation_request_date'>예약취소요청일<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_cancellation_request_date'
                readonly
                v-model="statusData.reservationCancellationRequestDate"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationCancellationRequestStatus === 1">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_cancellation_request_status_name'>예약취소요청<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_cancellation_request_status_name'
                readonly
                v-model="statusData.reservationCancellationRequestStatusName"
              />
            </div>
            <button class="Admin_PageDetail_Btn" v-on:click="cancellationComplete">처리 완료</button>
          </div>

          <div class="Admin_PageInfo pdl15 mgb40" v-if="statusData.reservationCancellationRequestStatus === 1">
            <p>예약취소요청 처리 안내</p>
            <p>1. 결제 여부와 상관없이 확인 후 반드시 처리 완료를 눌러주세요.</p>
            <p>2. 예약취소요청 처리완료를 해도 결제가 자동 취소되지 않습니다.</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_payment_method_name'>결제 방법<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_payment_method_name'
                readonly
                v-model="statusData.reservationPaymentMethodName"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.beforeReservationPayStatus === 1">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_cancle_real_amount'>취소금액<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_cancle_real_amount'
                maxLength="13"
                placeholder = "취소금액을 입력해 주세요."
                v-model="formData.reservationCancleRealAmount"
                @input="formatRealAmount"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_pay_status_name'>결제 여부<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_pay_status_name'
                readonly
                v-model="statusData.reservationPayStatusName"
              />
            </div>
            <button v-if="statusData.reservationPayStatus === 2" class="Admin_PageDetail_Btn" v-on:click="paymentComplete">결제 완료 처리</button>
            <button v-if="statusData.reservationPayStatus !== 3" class="Admin_PageDetail_Btn" v-on:click="paymentCancel">결제 취소 처리</button>
          </div>

          <div class="Admin_PageInfo pdl15 mgb40" v-if="statusData.reservationPayStatus !== 3">
            <p>결제 완료 / 결제 취소 처리 안내</p>
            <p>1. 결제 완료 시 적립(사용) 예정포인트가 예약자에게 지급(차감) 됩니다.</p>
            <p>2. 결제 완료 시 결제 예정금액으로 결제처리가 됩니다.</p>
            <p>3. 결제 취소 시 적립(사용)포인트가 0원이되며 환불(반환) 처리가 됩니다.</p>
            <p>4. 결제 취소 시 해당 예약인원 및 좌석배치가 초기화 됩니다.</p>
            <p>5. 결제 취소 시 해당 취소할 금액을 입력하셔야 합니다.</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPayStatus !== 3">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='total_reservation_number_count'>예약 인원<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'total_reservation_number_count'
                readonly
                v-model="statusData.totalReservationNumberCount"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPayStatus === 2">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_expected_payment_amount'>결제 예정금액</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_expected_payment_amount'
                maxLength="13"
                placeholder = "결제예정금액을 입력해 주세요."
                v-model="formData.reservationExpectedPaymentAmount"
                @input="formatAmount"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.reservationExpectedPaymentAmountError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPayStatus === 1">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_payment_amount'>결제 완료금액<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_payment_amount'
                readonly
                v-model="statusData.reservationPaymentAmount"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPayStatus === 1">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_fee'>정산 수수료<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_fee'
                readonly
                v-model="statusData.reservationFee"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPayStatus === 1">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_fee_amount'>정산 금액<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_fee_amount'
                readonly
                v-model="statusData.reservationFeeAmount"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPayStatus === 3">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_cancle_amount'>결제 취소금액<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_cancle_amount'
                readonly
                v-model="statusData.reservationCancleAmount"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPayStatus === 3">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_cancle_date'>결제 취소일자<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_cancle_date'
                readonly
                v-model="statusData.reservationCancleDate"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPayStatus === 2">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_accumulated_points'>적립 예정포인트<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_accumulated_points'
                readonly
                v-model="statusData.reservationAccumulatedPoints"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPayStatus === 2">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_use_points'>사용 예정포인트<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_use_points'
                readonly
                v-model="statusData.reservationUsePoints"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPayStatus === 1">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_accumulated_points'>적립 포인트<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_accumulated_points'
                readonly
                v-model="statusData.reservationAccumulatedPoints"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPayStatus === 1">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_use_points'>사용 포인트<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_use_points'
                readonly
                v-model="statusData.reservationUsePoints"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPaymentMethod === 0 && statusData.reservationPayStatus !== 3">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_cash_receipt_request'>현금영수증 요청<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_cash_receipt_request'
                readonly
                v-model="statusData.reservationCashReceiptRequest"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPaymentMethod === 0 && statusData.reservationPayStatus !== 3">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_refund_account'>환불 계좌<span class="pointTextRed13">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'reservation_refund_account'
                readonly
                v-model="statusData.reservationRefundCccount"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.reservationPayStatus !== 3">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='reservation_request'>요청사항<span class="pointTextRed13">(수정불가)</span></label>
              <textarea
                class="Admin_PageDetail_textarea"
                id="reservation_request"
                readonly
                v-model="statusData.reservationRequest"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_reservation_one,
  update_reservation,
  update_reservation_payment_complete,
  update_reservation_payment_cancle,
  update_reservation_payment_cancle_card,
  update_reservation_cancellation_complete
} from '../../ETC/Axios.vue'
import {
  removeWhitespace,
  removeWhitespacePhone,
  validatePhone,
  validateEmail
} from '../../ETC/Validation.vue'

export default {
  name: 'AdminReservationManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner

  },
  setup () {
    return {
      formData: ref({
        reservationCustomerName: '',
        reservationCustomerPhoneNumber: '',
        reservationCustomerPhoneNumber2: '',
        reservationCustomerEmail: '',
        reservationMemo: '',
        reservationExpectedPaymentAmount: '',
        reservationCancleRealAmount: '0'
      }),
      errorData: ref({
        reservationCustomerNameError: '',
        reservationCustomerPhoneNumberError: '',
        reservationCustomerPhoneNumber2Error: '',
        reservationCustomerEmailError: '',
        reservationExpectedPaymentAmountError: ''
      }),
      statusData: ref({
        customerIDUseReservation: '',
        reservationJoinDivision: '',
        reservationRegiste: '',
        travelProductName: '',
        scheduleStartDay: '',
        reservationCancellationRequestDate: '',
        reservationCancellationRequestStatus: 0,
        reservationCancellationRequestStatusName: '',
        reservationPaymentMethod: '',
        reservationPaymentMethodName: '',
        beforeReservationPayStatus: 0,
        reservationPayStatus: 0,
        reservationPayStatusName: '',
        totalReservationNumberCount: '',
        reservationPaymentAmount: '',
        reservationFee: '',
        reservationFeeAmount: '',
        reservationCancleAmount: '',
        reservationCancleDate: '',
        reservationAccumulatedPoints: '',
        reservationUsePoints: '',
        reservationCashReceiptRequest: '',
        reservationRefundCccount: '',
        reservationRequest: '',
        imp_uid: '',
        merchant_uid: '',
        reservationCustomerPhoneNumberStatus: false,
        reservationCustomerPhoneNumber2Status: true,
        reservationCustomerEmailStatus: true,
        spinnerStatus: false
      })
    }
  },
  watch: {
    'formData.reservationCustomerPhoneNumber': function (value) {
      const cleanValue = value.replace(/\D/g, '')
      this.formData.reservationCustomerPhoneNumber = removeWhitespacePhone(cleanValue)
      if (removeWhitespacePhone(value) === '') {
        this.errorData.reservationCustomerPhoneNumberError = '휴대전화는 필수로 입력하셔야 합니다.'
        this.statusData.reservationCustomerPhoneNumberStatus = false
      } else if (validatePhone(removeWhitespacePhone(value))) {
        this.errorData.reservationCustomerPhoneNumberError = ''
        this.statusData.reservationCustomerPhoneNumberStatus = true
      } else {
        this.errorData.reservationCustomerPhoneNumberError = '휴대폰번호 형식으로 입력하셔야 합니다.'
        this.statusData.reservationCustomerPhoneNumberStatus = false
      }
    },
    'formData.reservationCustomerPhoneNumber2': function (value) {
      const cleanValue = value.replace(/\D/g, '')
      this.formData.reservationCustomerPhoneNumber2 = removeWhitespacePhone(cleanValue)
      if (removeWhitespacePhone(value) === '') {
        this.errorData.reservationCustomerPhoneNumber2Error = ''
        this.statusData.reservationCustomerPhoneNumberStatus = true
      } else if (validatePhone(removeWhitespacePhone(value))) {
        this.errorData.reservationCustomerPhoneNumber2Error = ''
        this.statusData.reservationCustomerPhoneNumber2Status = true
      } else {
        this.errorData.reservationCustomerPhoneNumber2Error = '휴대폰번호 형식으로 입력하셔야 합니다.'
        this.statusData.reservationCustomerPhoneNumber2Status = false
      }
    },
    'formData.reservationCustomerEmail': function (value) {
      this.formData.reservationCustomerEmail = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.reservationCustomerEmailError = ''
        this.statusData.reservationCustomerEmailStatus = true
      } else if (validateEmail(removeWhitespace(value))) {
        this.errorData.reservationCustomerEmailError = ''
        this.statusData.reservationCustomerEmailStatus = true
      } else {
        this.errorData.reservationCustomerEmailError = '이메일 형식으로 입력하셔야 합니다.'
        this.statusData.reservationCustomerEmailStatus = false
      }
    }
  },
  methods: {
    cancellationComplete () {
      this.statusData.spinnerStatus = true
      update_reservation_cancellation_complete(
        this.$route.query.reservation_ID
      ).then(() => {
        this.statusData.spinnerStatus = false
        this.statusData.reservationCancellationRequestStatus = 2
        this.statusData.reservationCancellationRequestStatusName = '처리완료'
        alert('처리가 완료되었습니다.')
      })
    },
    paymentComplete () {
      this.statusData.spinnerStatus = true
      update_reservation_payment_complete(
        this.$route.query.reservation_ID,
        this.statusData.customerIDUseReservation,
        this.formData.reservationExpectedPaymentAmount.replace(/,/g, ''),
        this.statusData.reservationAccumulatedPoints.replace(/,/g, ''),
        this.statusData.reservationUsePoints.replace(/,/g, '')
      ).then(() => {
        this.statusData.spinnerStatus = false
        this.statusData.reservationPaymentAmount = this.formData.reservationExpectedPaymentAmount
        this.formData.reservationExpectedPaymentAmount = '0'
        this.statusData.reservationPayStatus = 1
        this.statusData.reservationPayStatusName = '완료'
        this.statusData.beforeReservationPayStatus = 1
        alert('결제가 완료되었습니다.')
      })
    },
    async paymentCancel () {
      this.statusData.spinnerStatus = true
      if (this.statusData.beforeReservationPayStatus === 1 && this.statusData.reservationPaymentMethod === 1) {
        update_reservation_payment_cancle_card(
          this.$route.query.reservation_ID,
          this.statusData.beforeReservationPayStatus,
          this.formData.reservationCancleRealAmount.replace(/\D/g, ''),
          this.statusData.customerIDUseReservation,
          this.statusData.reservationAccumulatedPoints.replace(/,/g, ''),
          this.statusData.reservationUsePoints.replace(/,/g, ''),
          this.statusData.imp_uid
        ).then((result) => {
          if (result.result_code === 0) {
            this.statusData.spinnerStatus = false
            this.statusData.reservationPayStatus = 3
            this.statusData.reservationPayStatusName = '결제취소'
            alert('결제가 취소되었습니다.')
          } else {
            this.statusData.spinnerStatus = false
            alert(`에러내용 : ${result.error} / 개발자에게 문의해주세요.`)
          }
        })
      } else {
        update_reservation_payment_cancle(
          this.$route.query.reservation_ID,
          this.statusData.beforeReservationPayStatus,
          this.formData.reservationCancleRealAmount.replace(/\D/g, ''),
          this.statusData.customerIDUseReservation,
          this.statusData.reservationAccumulatedPoints.replace(/,/g, ''),
          this.statusData.reservationUsePoints.replace(/,/g, '')
        ).then(() => {
          this.statusData.spinnerStatus = false
          this.statusData.reservationPayStatus = 3
          this.statusData.reservationPayStatusName = '결제취소'
          alert('결제가 취소되었습니다.')
        })
      }
    },
    formatAmount () {
      let value = this.formData.reservationExpectedPaymentAmount.replace(/\D/g, '')
      value = Number(value).toLocaleString()
      this.formData.reservationExpectedPaymentAmount = value
    },
    formatRealAmount () {
      let value = this.formData.reservationCancleRealAmount.replace(/\D/g, '')
      value = Number(value).toLocaleString()
      this.formData.reservationCancleRealAmount = value
    },
    check_form: function () {
      let continue_add = true
      if (this.formData.reservationCustomerName === '') {
        this.errorData.reservationCustomerNameError = '예약자명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.reservationCustomerNameError = ''
      }
      if (this.formData.reservationCustomerPhoneNumber === '') {
        this.errorData.reservationCustomerPhoneNumberError = '휴대전화를 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.reservationCustomerPhoneNumberError = ''
      }
      if (this.formData.reservationExpectedPaymentAmount === '') {
        this.errorData.reservationExpectedPaymentAmountError = '결제예정금액을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.reservationExpectedPaymentAmountError = ''
      }
      if (
        continue_add &&
        this.statusData.reservationCustomerPhoneNumberStatus &&
        this.statusData.reservationCustomerEmailStatus
      ) {
        this.statusData.spinnerStatus = true
        update_reservation(
          this.$route.query.reservation_ID,
          this.formData.reservationCustomerName,
          this.formData.reservationCustomerPhoneNumber,
          this.formData.reservationCustomerPhoneNumber2,
          this.formData.reservationCustomerEmail,
          this.formData.reservationMemo,
          this.formData.reservationExpectedPaymentAmount.replace(/,/g, '')
        ).then(() => {
          this.statusData.spinnerStatus = false
          alert('수정이 완료되었습니다.')
          window.location.href = '/AdminReservationManagement'
        })
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.reservation_ID !== undefined) {
      get_reservation_one(this.$route.query.reservation_ID).then((result) => {
        this.statusData.customerIDUseReservation = String(result[0].customer_ID_use_reservation)
        this.statusData.reservationJoinDivision = result[0].reservation_join_division
        this.statusData.reservationRegiste = result[0].reservation_registe
        this.statusData.travelProductName = result[0].travel_product_name
        this.statusData.scheduleStartDay = result[0].schedule_start_day
        this.statusData.reservationCancellationRequestDate = result[0].reservation_cancellation_request_date
        this.statusData.reservationCancellationRequestStatus = result[0].reservation_cancellation_request_status
        this.statusData.reservationCancellationRequestStatusName = result[0].reservation_cancellation_request_status_name
        this.statusData.reservationPaymentMethod = result[0].reservation_payment_method
        this.statusData.reservationPaymentMethodName = result[0].reservation_payment_method_name
        this.statusData.beforeReservationPayStatus = result[0].reservation_pay_status
        this.statusData.reservationPayStatus = result[0].reservation_pay_status
        this.statusData.reservationPayStatusName = result[0].reservation_pay_status_name
        this.statusData.totalReservationNumberCount = result[0].total_reservation_number_count
        this.statusData.reservationPaymentAmount = result[0].reservation_payment_amount.toLocaleString()
        this.statusData.reservationFee = result[0].reservation_fee.toLocaleString()
        this.statusData.reservationFeeAmount = (
          result[0].reservation_payment_amount * result[0].reservation_fee / 100
        ).toLocaleString()
        this.statusData.reservationCancleAmount = result[0].reservation_cancle_amount.toLocaleString()
        this.statusData.reservationCancleDate = result[0].reservation_cancle_date
        this.formData.reservationCancleRealAmount = result[0].reservation_payment_amount.toLocaleString()
        this.statusData.reservationAccumulatedPoints = result[0].reservation_accumulated_points.toLocaleString()
        this.statusData.reservationUsePoints = result[0].reservation_use_points.toLocaleString()
        this.statusData.reservationCashReceiptRequest = result[0].reservation_cash_receipt_request
        this.statusData.reservationRefundCccount = result[0].reservation_refund_account
        this.statusData.reservationRequest = result[0].reservation_request
        this.statusData.imp_uid = result[0].imp_uid
        this.statusData.merchant_uid = result[0].merchant_uid
        this.formData.reservationCustomerName = result[0].reservation_customer_name
        this.formData.reservationCustomerPhoneNumber = result[0].reservation_customer_phone_number
        this.formData.reservationCustomerPhoneNumber2 = result[0].reservation_customer_phone_number_2
        this.formData.reservationCustomerEmail = result[0].reservation_customer_email
        this.formData.reservationMemo = result[0].reservation_memo
        this.formData.reservationExpectedPaymentAmount = result[0].reservation_expected_payment_amount.toLocaleString()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/ReservationManagement/AdminReservationManagementAdd.vue